import { render, staticRenderFns } from "./Grid.vue?vue&type=template&id=28132d3a"
import script from "./Grid.vue?vue&type=script&lang=js"
export * from "./Grid.vue?vue&type=script&lang=js"
import style0 from "./Grid.vue?vue&type=style&index=0&id=28132d3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports